import React from 'react'

interface ChatLiveIconProps {
  size?: number
  color?: string
  showBackground?: boolean
  className?: string
}

export const ChatLiveIcon: React.FC<ChatLiveIconProps> = ({
  size = 32,
  color = 'white',
  showBackground = true,
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_437_15167)">
        {showBackground && (
          <rect width="32" height="32" rx="16" fill="black" fillOpacity="0.2" />
        )}
        <circle
          cx="16"
          cy="16"
          r="5.39141"
          stroke={color}
          strokeWidth="1.1"
          strokeLinecap="round"
        />
        <path
          d="M16.6816 23.9751C17.0958 23.9751 17.4315 24.311 17.4316 24.7251C17.4316 25.1393 17.0959 25.4751 16.6816 25.4751C16.2674 25.4751 15.9316 25.1393 15.9316 24.7251C15.9317 24.311 16.2675 23.9751 16.6816 23.9751ZM11.7949 23.397C12.0021 23.0385 12.4607 22.9155 12.8193 23.1226C13.178 23.3296 13.3007 23.7883 13.0938 24.147C12.8866 24.5057 12.4281 24.6285 12.0693 24.4214C11.7107 24.2143 11.5878 23.7557 11.7949 23.397ZM20.4531 22.7817C20.8118 22.5748 21.2705 22.6985 21.4775 23.0571C21.6844 23.4158 21.5617 23.8745 21.2031 24.0815C20.8446 24.2885 20.3859 24.1655 20.1787 23.8071C19.9716 23.4484 20.0944 22.9888 20.4531 22.7817ZM8.87598 20.1782C9.23466 19.9713 9.69334 20.095 9.90039 20.4536C10.1072 20.8123 9.98459 21.271 9.62598 21.478C9.2674 21.685 8.80877 21.562 8.60156 21.2036C8.39446 20.8449 8.51726 20.3853 8.87598 20.1782ZM23.123 19.8628C23.3302 19.5043 23.7888 19.3814 24.1475 19.5884C24.5061 19.7955 24.6289 20.2541 24.4219 20.6128C24.2148 20.9715 23.7562 21.0943 23.3975 20.8872C23.0389 20.68 22.916 20.2214 23.123 19.8628ZM7.27539 15.2505C7.6896 15.2505 8.02539 15.5863 8.02539 16.0005C8.02518 16.4145 7.68947 16.7505 7.27539 16.7505C6.86131 16.7505 6.5256 16.4145 6.52539 16.0005C6.52539 15.5863 6.86118 15.2505 7.27539 15.2505ZM24.7256 15.2505C25.1398 15.2505 25.4756 15.5863 25.4756 16.0005C25.4754 16.4145 25.1397 16.7505 24.7256 16.7505C24.3115 16.7505 23.9758 16.4145 23.9756 16.0005C23.9756 15.5863 24.3114 15.2505 24.7256 15.2505ZM23.9873 11.4536C24.346 11.2465 24.8046 11.3693 25.0117 11.728C25.2188 12.0867 25.0959 12.5453 24.7373 12.7524C24.3786 12.9595 23.92 12.8367 23.7129 12.478C23.5058 12.1193 23.6286 11.6607 23.9873 11.4536ZM8.01074 11.1382C8.21785 10.7795 8.67644 10.6567 9.03516 10.8638C9.3938 11.0709 9.51666 11.5295 9.30957 11.8882C9.10238 12.2467 8.64377 12.3696 8.28516 12.1626C7.92651 11.9555 7.80382 11.4969 8.01074 11.1382ZM20.5195 8.28467C20.7267 7.9261 21.1853 7.80319 21.5439 8.01025C21.9026 8.21736 22.0254 8.67598 21.8184 9.03467C21.6113 9.39339 21.1527 9.51619 20.7939 9.30908C20.4353 9.10197 20.3124 8.64338 20.5195 8.28467ZM11.7285 7.66943C12.0871 7.46252 12.5458 7.58538 12.7529 7.94385C12.96 8.30248 12.837 8.76108 12.4785 8.96826C12.1198 9.17537 11.6612 9.05257 11.4541 8.69385C11.2471 8.33515 11.3698 7.87651 11.7285 7.66943ZM16.6816 6.5249C17.0959 6.5249 17.4316 6.86069 17.4316 7.2749C17.4316 7.68912 17.0959 8.0249 16.6816 8.0249C16.2674 8.0249 15.9316 7.68912 15.9316 7.2749C15.9316 6.86069 16.2674 6.5249 16.6816 6.5249Z"
          fill={color}
        />
        <path
          d="M17.7695 15.6041C18.1029 15.7965 18.1029 16.2777 17.7695 16.4701L15.291 17.9011C14.9577 18.0935 14.541 17.853 14.541 17.4681V14.6061C14.541 14.2212 14.9577 13.9807 15.291 14.1731L17.7695 15.6041Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_437_15167">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ChatLiveIcon
